<template>
    <div class="delete">
        <el-dialog title="提示" width="580px" :visible.sync="deleteVisible" :close-on-click-modal="false">
                <p>
                    <i class="el-icon-warning warning fz-16"></i>
                    <span class="content ml-6">{{ content }}</span>
                </p>
                <div class="fz-14 mt-10 ml-20" v-if="type === '2'">
                    <p>{{ tipMap.get(tipType) }}</p>
                    <p>1、商品无法推广给达人</p>
                    <p>2、在合作进度管理中，商品无法继续带货合作</p>
                </div>
                <div class="fz-14 mt-24 ml-20" v-if="type === '4'">
                    <p><el-radio v-model="radio" label="0">仅删除货盘，不删除货盘商品</el-radio></p>
                    <p><el-radio v-model="radio" label="1"  class="mt-20">删除货盘，并删除货盘商品</el-radio></p>
                    <div class="des mt-12 ml-24" v-if="radio === '1'">
                        商品无法被推广给达人，并且在合作进度中的商品无法继续带货合作
                    </div>
                </div>
                <div slot="footer">
                    <el-button @click="deleteVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirm">确 定</el-button>
                </div>
        </el-dialog>
    </div>
</template>
<script>
import { delGroup, delProduct, restoreProduct, delPallet } from "@/api/shopManage";
export default {
    data() {
        return {
            deleteVisible: false,
            content: '',
            row: {},
            type: '',
            radio: '0',
            tipType: '',
            tipMap: new Map([['single_library','删除商品后将导致'],['batch_library','批量删除商品仅可删除本人认领的商品(对他人认领的商品不生效)，商品删除后将导致']])
        }
    },
    methods: {
        delInit(row, type, content,tipType) {
            this.row = row
            this.type = type
            this.deleteVisible = true
            this.content = content;
            this.tipType = tipType;
        },
        async confirm() {
            let res;
            const {row: {product_id, id}, radio, } = this
            switch(this.type) {
                case '1':
                    res = await delGroup({group_id: id})
                    if(res.code === 0) {
                        this.$message.success('操作成功')
                        this.deleteVisible = false
                        this.$emit('delSuccess')
                    }
                    break;
                case '2':
                    res = await delProduct({product_ids: product_id})
                    if(res.code === 0) {
                        this.$message.success('操作成功')
                        this.deleteVisible = false
                        this.$emit('delSuccess')
                    }
                    break;
                case '3': 
                    res = await restoreProduct({product_id: product_id})
                    if(res.code === 0) {
                        this.$message.success('操作成功')
                        this.deleteVisible = false
                        this.$emit('delSuccess')
                    }
                    break;
                case '4':
                    res = await delPallet({is_del_product: radio, pallet_id: id})
                    if(res.code === 0) {
                        this.$message.success('操作成功')
                        this.deleteVisible = false
                        this.$emit('delSuccess')
                    }
                    break;
            } 
            
            
        }
    }
}
</script>
<style lang='less' scoped>
.warning{
    color: #FA8F14;
}
.content{
    font-weight: 500;
    color: #333333;
}
.des{
    padding: 8px;
    color: #FA8F14;
    background: #FFF5ED;
    border: 1px solid #FDD2A1;
    font-size: 13px;
}
</style>
